<template>
  <div
    :id="id"
    style="width: 100%; height:100%;"
  />
</template>

<script>
import { isBingMapLoaded } from '@/utils/misc';

export default {
  props: {
    id: {
      type: String,
      default: 'bing-map',
    },
    center: {
      type: Object,
      default: undefined,
    },
    paths: {
      type: Array,
      default() {
        return [];
      },
    },
    showPushPin: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.isBingMapLoaded()) {
      this.initMap();
      return;
    }

    window.OnLoadBingMapsApi = () => {
      this.initMap();
    };
  },
  methods: {
    isBingMapLoaded,
    initMap() {
      /* eslint-disable no-undef */
      const center = this.center
        ? new Microsoft.Maps.Location(this.center.lat, this.center.lng)
        : '';

      const map = new Microsoft.Maps.Map(document.getElementById(this.id), {
        center,
        zoom: 12,
      });

      const directionWaypointLayer = new Microsoft.Maps.Layer();

      map.layers.insert(directionWaypointLayer);

      if (this.showPushPin && center) {
        const pin = new Microsoft.Maps.Pushpin(center, {
          title: this.center.formatted_address || this.center.address,
        });

        map.entities.push(pin);
      }

      Microsoft.Maps.loadModule('Microsoft.Maps.Directions', () => {
        const directionsManager = new Microsoft.Maps.Directions.DirectionsManager(
          map,
        );
        // Set Route Mode to transit
        directionsManager.setRequestOptions({
          routeMode: Microsoft.Maps.Directions.RouteMode.truck,
        });

        // Set Render Options
        directionsManager.setRenderOptions({
          firstWaypointPushpinOptions: { visible: false },
          lastWaypointPushpinOptions: { visible: false },
          waypointPushpinOptions: { visible: false },
        });

        // create route with waypoints
        const wayPoints = [];
        this.paths.forEach((path) => {
          const waypoint1 = new Microsoft.Maps.Directions.Waypoint({
            location: new Microsoft.Maps.Location(
              path.coords.latitude,
              path.coords.longitude,
            ),
          });
          wayPoints.push(waypoint1);
        });

        // add pushpins on routes
        const pushPin = [];
        this.paths.forEach((path, index) => {
          const pin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(
            path.coords.latitude,
            path.coords.longitude,
          ), {
            anchor: new Microsoft.Maps.Point(9, 9),
            icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 36 34" xml:space="preserve"><circle cx="16" cy="16" r="14" style="fill:{color}" /><text x="16" y="21" style="font-size:16px;font-family:arial;fill:#ffffff;" text-anchor="middle">{text}</text></svg>',
            color: index === 0 || (index === this.paths.length - 1) ? '#2d2f54' : '#737373',
            text: `${index + 1}`,
            title: path.address.postcode,
          });

          pushPin.push(pin);
        });

        // add pushpins to map
        directionWaypointLayer.add(pushPin);

        // add waypoints to map
        wayPoints.forEach((waypoint) => {
          directionsManager.addWaypoint(waypoint);
        });

        directionsManager.calculateDirections();
      });
    },
  },
};
</script>
